module.exports = __webpack_public_path__ + "media/share.bb5fe5bb.svg";